/** Must match backend HOME_SECTION_KEYS */
export const HOME_SECTION_KEYS: string[] = [
  'continueListening',
  'dailyReset',
  'oracleCard',
  'deeperOracleReading',
  'quickTools',
  'newRelease',
  'recommended',
  'progressOverview',
  'askKaren',
  'upcomingEvents',
];

/** Parent categories linked to a stable home section key (labels come from the API). */
export const CATEGORY_HOME_SECTION_KEYS: string[] = ['dailyReset', 'quickTools'];

export const CATEGORY_HOME_SECTION_KEY_OPTIONS: { value: string; label: string }[] = [
  { value: '', label: 'None' },
  { value: 'dailyReset', label: 'dailyReset (category display name shown in app)' },
  { value: 'quickTools', label: 'quickTools (category display name shown in app)' },
];

/** Fallback labels for static sections when API labels are unavailable. */
export const STATIC_HOME_SECTION_LABELS: Record<string, string> = {
  continueListening: 'Continue Listening',
  oracleCard: 'Oracle Card',
  deeperOracleReading: 'Deeper Oracle Reading',
  newRelease: 'New Release',
  recommended: 'Recommended For You',
  progressOverview: 'Progress Overview',
  askKaren: 'Ask Karen',
  upcomingEvents: 'Upcoming Events',
};
